export default  {
    /**
     * @return {string}
     */
    YYYY_MM_DD_HH_MM_SS(date) {
        return date.getFullYear()
            + "-"
            + (date.getMonth() + 1)
            + "-"
            + date.getDate()
            + " "
            + date.getHours()
            + ":"
            + date.getMinutes()
            + ":"
            + date.getSeconds()


    },
    dateFormat(strdate,lang)
    {
        if((strdate === null)||(strdate === ''))
        {
            return "";
        }
        
        //console.log("strdate: '"+strdate+"' ");
        
        //this.langsel = this.$store.state.language;
        
        //console.log("lang: " + lang);

        let date = new Date(strdate);
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();

        let hour = date.getHours();
        //Horas con 2 digitos
        hour = ("0" + hour).slice(-2);

        let minute = date.getMinutes();
        //Minutos con 2 digitos
        minute = ("0" + minute).slice(-2);

        switch(lang)
        {
            case "es":
            return  day +"/" + month + "/" + year + " " + hour + ":" + minute;
           
            
            case "pt":
            return  day +"/" + month + "/" + year + " " + hour + ":" + minute;
           

            case "en":
            return  month +"/" + day + "/" + year + " " + hour + ":" + minute;

            default:
            return  day +"/" + month + "/" + year + " " + hour + ":" + minute;
        }
        
    },
    onlyDateFormat(strdate,lang)
    {
        if((strdate === null)||(strdate === ''))
        {
            return "";
        }
        
        //console.log("strdate: '"+strdate+"' ");
        
        //this.langsel = this.$store.state.language;
        
        //console.log("lang: " + lang);

        let date = new Date(strdate);
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();

        switch(lang)
        {
            case "es":
            return  day +"/" + month + "/" + year;
           
            
            case "pt":
            return  day +"/" + month + "/" + year;
           

            case "en":
            return  month +"/" + day + "/" + year;

            default:
            return  day +"/" + month + "/" + year;
        }
        
    },
    dateOffset(fechaHoraString, offsetHoras)  //De Chat GPT
    {
        if((fechaHoraString === null)||(fechaHoraString === ''))
        {
            return "";
        }        
        // Crear un objeto Date a partir del string de fecha/hora
        let fechaHora = new Date(fechaHoraString);

        // Ajustar la fecha/hora según el offset de horas
        fechaHora.setHours(fechaHora.getHours() + offsetHoras);

        // Obtener los componentes de la fecha/hora
        let ano = fechaHora.getFullYear();
        let mes = (fechaHora.getMonth() + 1).toString().padStart(2, '0');
        let dia = fechaHora.getDate().toString().padStart(2, '0');
        let hora = fechaHora.getHours().toString().padStart(2, '0');
        let minuto = fechaHora.getMinutes().toString().padStart(2, '0');
        let segundo = fechaHora.getSeconds().toString().padStart(2, '0');

        // Formatear la fecha/hora resultante
        let fechaFormateada = `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}`;

        return fechaFormateada;
        
        
       /* // Crear un objeto Date a partir del string de fecha/hora
        let fechaHora = new Date(fechaHoraString);
    
        // Ajustar la fecha/hora según el offset de horas
        fechaHora.setHours(fechaHora.getHours() + offsetHoras);
    
        // Formatear la fecha/hora resultante
        let fechaFormateada = fechaHora.toISOString().slice(0, 19).replace("T", " ");
        console.log("fechaFormateada: " + fechaFormateada);
    
        // Completar con ceros a la izquierda si es necesario
        let [fecha, hora] = fechaFormateada.split(' ');
        let [ano, mes, dia] = fecha.split('-');
        let [horaStr, minuto, segundo] = hora.split(':');
    
        fechaFormateada = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')} ${horaStr.padStart(2, '0')}:${minuto.padStart(2, '0')}:${segundo.padStart(2, '0')}`;
    
        return fechaFormateada;
        */
    }
    
    // Ejemplo de uso
    /*let fechaHoraOriginal = "2023-12-12 03:00:00";
    let offsetHoras = 5;
    let nuevaFechaHora = ajustarFechaConOffset(fechaHoraOriginal, offsetHoras);
    
    console.log(`Fecha/hora original: ${fechaHoraOriginal}`);
    console.log(`Nuevo fecha/hora: ${nuevaFechaHora}`);
    */
    
}